import { Component } from '@angular/core';

@Component({
    selector: 'app-popup-header',
    templateUrl: './popup-header.component.html',
    styleUrls: ['./popup-header.component.scss'],
    standalone: false
})
export class PopupHeaderComponent {

}
